import { PrimeIcons } from 'primereact/api';
import React, { useMemo } from 'react';
import { Tooltip } from 'react-tooltip';
import './InfoIcon.scss';
import classNames from 'classnames';

interface Props {
  content: string | React.ReactNode;
  icon?: typeof PrimeIcons.QUESTION_CIRCLE | typeof PrimeIcons.INFO_CIRCLE;
  size?: 'small' | 'medium';
}

export const InfoIcon = ({ content, icon = PrimeIcons.QUESTION_CIRCLE, size = 'medium' }: Props) => {
  const tooltipId = useMemo(() => `tooltip-${Math.random().toString(36).substring(2, 16)}`, []);

  return (
    <>
      <i
        id={tooltipId}
        className={classNames('info-icon', icon, {
          'info-icon-small': size === 'small',
        })}
      />
      <Tooltip anchorSelect={`#${tooltipId}`}>{content}</Tooltip>
    </>
  );
};
